import { gql } from '@apollo/client';

export default gql`
  mutation createSquadsShifts($input: CreateSquadsShiftsInput!) {
    createSquadsShifts(input: $input) {
      count
    }
  }
`;
